<template lang="pug">
  nav
    .nav_area
      .sub_title(v-if="mode != 3") {{title}}
      .labels(v-if="mode < 4")
        .label(:class="{active:mode === 1}")
          span STEP 1
          span 相続関係図作成
        .arrow
        .label(:class="{active:mode === 2}")
          span STEP 2
          span 遺産入力
        .arrow
        .label(:class="{active:mode === 3}")
          span GOAL
          span 配分表
</template>

<script lang="js">
export default {
  props: {
    mode: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="sass" scoped>
nav
  height: 60px
  background-color: $header-background-color
  margin-bottom: 20px
  .nav_area
    position: relative
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    box-sizing: border-box
    margin: auto
    width: $max-width
    height: 100%
    .labels
      display: flex
      position: absolute
      left: 0
      .label
        display: flex
        flex-direction: column
        padding: 6px
        span
          display: block
          &:nth-of-type(1)
            font-size: 16px
            text-align: center
          &:nth-of-type(2)
            font-size: 10px
            padding-top: 4px
        &:nth-of-type(n+2)
          margin-left: 18px
      .arrow
        padding: 0 8px
        position: relative
        &:after
          content: "▶"
          position: absolute
          font-size: 12px
          top: 9px
    .sub_title
      text-align: center
      width: 100%
      font-size: 16px
      color: $main-light-blue
      font-weight: bold
      display: flex
      justify-content: center
      align-items: center
    .active
      color: $main-light-blue
    .none_pc
      display: none
@media screen and (max-width: $break-header)
  nav
    background-color: $white
    height: auto
    margin-bottom: 60px
    .nav_area
      width: 100%
      flex-direction: column-reverse
      padding: 0 10px
      .labels
        justify-content: center
        position: initial
        padding: 30px
        .label
          span
            text-align: center
            &:nth-of-type(1)
              font-size: 17px
              white-space: nowrap
            &:nth-of-type(2)
              font-size: 12px
              white-space: nowrap
        .arrow
          &:after
            top: 12px
      .sub_title
        border-top: solid 1px #000
        border-bottom: solid 1px #000
        height: 60px
      .none_pc
        display: block
</style>